var _ellipse, _ellipse2, _ellipse3, _circle, _circle2, _ellipse4, _ellipse5, _circle3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3DIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 106,
    viewBox: "0 0 98 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9998,
    cy: 8.5,
    rx: 8,
    ry: 7.5,
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9998,
    cy: 52.5,
    rx: 8,
    ry: 7.5,
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.4998,
    cy: 74,
    rx: 7.5,
    ry: 8,
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.9998,
    cy: 97,
    r: 8,
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.4998,
    cy: 31.5,
    r: 7.5,
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.49976,
    cy: 74,
    rx: 7.5,
    ry: 8,
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.49976,
    cy: 74,
    rx: 7.5,
    ry: 8,
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.49976,
    cy: 31.5,
    r: 7.5,
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 42.8483,
    y1: 12.9877,
    x2: 16.1039,
    y2: 28.9445,
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 82.1185,
    y1: 28.9438,
    x2: 55.3741,
    y2: 12.9869,
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 55.3736,
    y1: 92.4659,
    x2: 82.118,
    y2: 76.509,
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 16.1032,
    y1: 76.5098,
    x2: 42.8476,
    y2: 92.4667,
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 9.99976,
    y1: 40,
    x2: 9.99976,
    y2: 65,
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 40.9917,
    y1: 49.6028,
    x2: 16.0074,
    y2: 36.5158,
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 16.0068,
    y1: 68.9381,
    x2: 40.9911,
    y2: 55.8511,
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 4"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 82.2149,
    y1: 36.5154,
    x2: 57.2306,
    y2: 49.6024,
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 87.9998,
    y1: 65,
    x2: 87.9998,
    y2: 40,
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 81.2869,
    y1: 70.7098,
    x2: 56.3026,
    y2: 57.6228,
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 4"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 49.9998,
    y1: 60,
    x2: 49.9998,
    y2: 89,
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 49.9998,
    y1: 17,
    x2: 49.9998,
    y2: 44,
    stroke: "#D6D6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DIcon);
export default __webpack_public_path__ + "static/media/3dIcon.50468ebed7990bfdabc43b3de5733e54.svg";
export { ForwardRef as ReactComponent };